(() => {
  // assets/scripts/magnify.ts
  var overlay;
  var createOverlay = (image) => {
    const overlayImage = document.createElement("img");
    overlayImage.setAttribute("src", `${image.src}`);
    overlay = document.createElement("div");
    prepareOverlay(overlay, overlayImage);
    image.style.opacity = "50%";
    toggleLoadingSpinner(image);
    overlayImage.onload = () => {
      toggleLoadingSpinner(image);
      image.parentElement?.insertBefore(overlay, image);
      image.style.opacity = "100%";
    };
    return overlay;
  };
  var prepareOverlay = (container, image) => {
    container.setAttribute("class", "image-magnify-full-size");
    container.setAttribute("aria-hidden", "true");
    container.style.backgroundImage = `url('${image.src}')`;
    container.style.backgroundColor = "var(--gradient-background)";
  };
  var toggleLoadingSpinner = (image) => {
    const loadingSpinner =
      image.parentElement?.parentElement?.querySelector(`.loading__spinner`);
    loadingSpinner?.classList.toggle("hidden");
  };
  var moveWithHover = (image, event, zoomRatio) => {
    const ratio = image.height / image.width;
    const container = event.target.getBoundingClientRect();
    const xPosition = event.clientX - container.left;
    const yPosition = event.clientY - container.top;
    const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
    const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;
    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
  };
  var magnify = (image, zoomRatio) => {
    const overlay2 = createOverlay(image);
    overlay2.onclick = () => overlay2.remove();
    overlay2.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
    overlay2.onmouseleave = () => overlay2.remove();
  };
  var enableZoomOnHover = (zoomRatio) => {
    const images = document.querySelectorAll(".image-magnify-hover");
    images.forEach((image) => {
      image.onclick = (event) => {
        magnify(image, zoomRatio);
        moveWithHover(image, event, zoomRatio);
      };
    });
  };
  enableZoomOnHover(2);
  // utils/components/cart-performance.ts
  class CartPerformance {
    static #metric_prefix = "cart-performance";
    static createStartingMarker(benchmarkName) {
      const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
      return performance.mark(`${metricName}:start`);
    }
    static measureFromEvent(benchmarkName, event) {
      const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
      const startMarker = performance.mark(`${metricName}:start`, {
        startTime: event.timeStamp,
      });
      const endMarker = performance.mark(`${metricName}:end`);
      performance.measure(
        metricName,
        `${metricName}:start`,
        `${metricName}:end`,
      );
    }
    static measureFromMarker(benchmarkName, startMarker) {
      const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
      const endMarker = performance.mark(`${metricName}:end`);
      performance.measure(metricName, startMarker.name, `${metricName}:end`);
    }
    static measure(benchmarkName, callback) {
      const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
      const startMarker = performance.mark(`${metricName}:start`);
      callback();
      const endMarker = performance.mark(`${metricName}:end`);
      performance.measure(
        metricName,
        `${metricName}:start`,
        `${metricName}:end`,
      );
    }
  }
  // utils/components/deferred-media.ts
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener("click", () => this.loadContent());
    }
    loadContent(focus = true) {
      window.pauseAllMedia();
      if (!this.getAttribute("loaded")) {
        const content = document.createElement("div");
        const template = this.querySelector("template");
        const firstElement = template?.content.firstElementChild;
        if (firstElement) {
          content.appendChild(firstElement.cloneNode(true));
        }
        this.setAttribute("loaded", "true");
        const mediaElement = content.querySelector(
          "video, model-viewer, iframe",
        );
        if (!mediaElement) return;
        const deferredElement = this.appendChild(mediaElement);
        if (focus && typeof deferredElement.focus === "function") {
          deferredElement.focus();
        }
        if (
          deferredElement.nodeName === "VIDEO" &&
          deferredElement.getAttribute("autoplay")
        ) {
          deferredElement.play?.();
        }
        const formerStyle = deferredElement.getAttribute("style");
        deferredElement.setAttribute("style", "display: block;");
        window.setTimeout(() => {
          deferredElement.setAttribute("style", formerStyle ?? "");
        }, 0);
      }
    }
  }
  // utils/components/html-update-utility.ts
  class HTMLUpdateUtility {
    static viewTransition(
      oldNode,
      newContent,
      preProcessCallbacks = [],
      postProcessCallbacks = [],
    ) {
      if (!oldNode || !newContent) return;
      preProcessCallbacks?.forEach((callback) => callback(newContent));
      const newNodeWrapper = document.createElement("div");
      HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
      const newNode = newNodeWrapper.firstChild;
      const uniqueKey = Date.now();
      oldNode.querySelectorAll("[id], [form]").forEach((element) => {
        const htmlElement = element;
        if (htmlElement.id) {
          htmlElement.id = `${htmlElement.id}-${uniqueKey}`;
        }
        const formElement = element;
        if (formElement.form) {
          element.setAttribute(
            "form",
            `${formElement.form.getAttribute("id")}-${uniqueKey}`,
          );
        }
      });
      if (oldNode.parentNode && newNode) {
        oldNode.parentNode.insertBefore(newNode, oldNode);
      }
      oldNode.style.display = "none";
      postProcessCallbacks?.forEach((callback) => callback(newNode));
      setTimeout(() => oldNode.remove(), 500);
    }
    static setInnerHTML(element, html) {
      element.innerHTML = html;
      element.querySelectorAll("script").forEach((oldScriptTag) => {
        const newScriptTag = document.createElement("script");
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(
          document.createTextNode(oldScriptTag.innerHTML),
        );
        oldScriptTag.parentNode?.replaceChild(newScriptTag, oldScriptTag);
      });
    }
  }
  // assets/scripts/product/product-model.ts
  class ProductModel extends DeferredMedia {
    modelViewerUI;
    constructor() {
      super();
    }
    loadContent() {
      super.loadContent();
      window.Shopify.loadFeatures([
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }
    setupModelViewerUI(errors) {
      if (errors) return;
      this.modelViewerUI = new window.Shopify.ModelViewerUI(
        this.querySelector("model-viewer"),
      );
    }
    static loadShopifyXR() {
      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: ProductModel.setupShopifyXR.bind(ProductModel),
        },
      ]);
    }
    static setupShopifyXR(errors) {
      if (errors) return;
      if (!window.ShopifyXR) {
        document.addEventListener("shopify_xr_initialized", () =>
          ProductModel.setupShopifyXR(),
        );
        return;
      }
      document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
        const textContent = modelJSON.textContent;
        if (textContent) {
          window.ShopifyXR?.addModels(JSON.parse(textContent));
        }
        modelJSON.remove();
      });
      window.ShopifyXR?.setupXRElements();
    }
  }
  if (!customElements.get("product-model")) {
    customElements.define("product-model", ProductModel);
  }
  window.addEventListener("DOMContentLoaded", () => {
    if (ProductModel) ProductModel.loadShopifyXR();
  });

  // utils/sectionId.ts
  class SectionId {
    static #separator = "__";
    static parseId(qualifiedSectionId) {
      return qualifiedSectionId.split(SectionId.#separator)[0];
    }
    static parseSectionName(qualifiedSectionId) {
      return qualifiedSectionId.split(SectionId.#separator)[1];
    }
    static getIdForSection(sectionId, sectionName) {
      return `${sectionId}${SectionId.#separator}${sectionName}`;
    }
  }

  // assets/scripts/product/product-info.ts
  class ProductInfo extends HTMLElement {
    quantityInput;
    quantityForm;
    onVariantChangeUnsubscriber;
    cartUpdateUnsubscriber;
    abortController;
    pendingRequestUrl = null;
    preProcessHtmlCallbacks = [];
    postProcessHtmlCallbacks = [];
    constructor() {
      super();
      this.quantityInput = this.querySelector(".quantity__input");
    }
    connectedCallback() {
      this.initializeProductSwapUtility();
      this.onVariantChangeUnsubscriber = window.subscribe(
        window.PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this),
      );
      this.initQuantityHandlers();
      this.dispatchEvent(
        new CustomEvent("product-info:loaded", { bubbles: true }),
      );
    }
    addPreProcessCallback(callback) {
      this.preProcessHtmlCallbacks.push(callback);
    }
    initQuantityHandlers() {
      if (!this.quantityInput) return;
      this.quantityForm = this.querySelector(".product-form__quantity");
      if (!this.quantityForm) return;
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = window.subscribe(
          window.PUB_SUB_EVENTS.cartUpdate,
          this.fetchQuantityRules.bind(this),
        );
      }
    }
    disconnectedCallback() {
      this.onVariantChangeUnsubscriber?.();
      this.cartUpdateUnsubscriber?.();
    }
    initializeProductSwapUtility() {
      this.preProcessHtmlCallbacks.push((html) =>
        html
          .querySelectorAll(".scroll-trigger")
          .forEach((element) =>
            element.classList.add("scroll-trigger--cancel"),
          ),
      );
      this.postProcessHtmlCallbacks.push(() => {
        window?.Shopify?.PaymentButton?.init();
        ProductModel.loadShopifyXR();
      });
    }
    handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
      if (!this.contains(event.target)) return;
      this.resetProductFormState();
      const productUrl =
        target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
      this.pendingRequestUrl = productUrl ?? null;
      const shouldSwapProduct = this.dataset.url !== productUrl;
      const shouldFetchFullPage =
        this.dataset.updateUrl === "true" && shouldSwapProduct;
      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(
          productUrl ?? "",
          selectedOptionValues,
          shouldFetchFullPage,
        ),
        targetId: target.id,
        callback: shouldSwapProduct
          ? this.handleSwapProduct(productUrl ?? "", shouldFetchFullPage)
          : this.handleUpdateProductInfo(productUrl ?? ""),
      });
    }
    resetProductFormState() {
      const productForm = this.productForm;
      productForm?.toggleSubmitButton(true);
      productForm?.handleErrorMessage();
    }
    handleSwapProduct(productUrl, updateFullPage) {
      return (html) => {
        this.productModal?.remove();
        const selector = updateFullPage
          ? "product-info[id^='MainProduct']"
          : "product-info";
        const variant = this.getSelectedVariant(html.querySelector(selector));
        this.updateURL(productUrl, variant?.id);
        if (updateFullPage) {
          const headTitle = document.querySelector("head title");
          const htmlHeadTitle = html.querySelector("head title");
          if (headTitle && htmlHeadTitle) {
            headTitle.innerHTML = htmlHeadTitle.innerHTML;
          }
          HTMLUpdateUtility.viewTransition(
            document.querySelector("main"),
            html.querySelector("main"),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks,
          );
        } else {
          HTMLUpdateUtility.viewTransition(
            this,
            html.querySelector("product-info"),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks,
          );
        }
      };
    }
    renderProductInfo({ requestUrl, targetId, callback }) {
      this.abortController?.abort();
      this.abortController = new AbortController();
      fetch(requestUrl, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          this.pendingRequestUrl = null;
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          callback(html);
        })
        .then(() => {
          document.querySelector(`#${targetId}`)?.focus({
            preventScroll: true,
          });
        })
        .catch((error) => {
          if (error.name === "AbortError") {
            console.log("Fetch aborted by user");
          } else {
            console.error(error);
          }
        });
    }
    getSelectedVariant(productInfoNode) {
      const selectedVariant = productInfoNode?.querySelector(
        "variant-selects [data-selected-variant]",
      )?.innerHTML;
      return selectedVariant ? JSON.parse(selectedVariant) : null;
    }
    buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
      const params = [];
      if (!shouldFetchFullPage) {
        params.push(`section_id=${this.sectionId}`);
      }
      if (optionValues.length) {
        params.push(`option_values=${optionValues.join(",")}`);
      }
      return `${url}?${params.join("&")}`;
    }
    updateOptionValues(html) {
      const variantSelects = html.querySelector("variant-selects");
      if (variantSelects) {
        HTMLUpdateUtility.viewTransition(
          this.variantSelectors,
          variantSelects,
          this.preProcessHtmlCallbacks,
        );
      }
    }
    handleUpdateProductInfo(productUrl) {
      return (html) => {
        const variant = this.getSelectedVariant(html);
        this.pickupAvailability?.update(variant);
        this.updateOptionValues(html);
        this.updateURL(productUrl, variant?.id);
        this.updateVariantInputs(variant?.id);
        if (!variant) {
          this.setUnavailable();
          return;
        }
        this.updateMedia(html, variant?.featured_media?.id);
        const updateSourceFromDestination = (id, shouldHide = () => false) => {
          const source = html.getElementById(`${id}-${this.sectionId}`);
          const destination = this.querySelector(
            `#${id}-${this.dataset.section}`,
          );
          if (source && destination) {
            destination.innerHTML = source.innerHTML;
            destination.classList.toggle("hidden", shouldHide(source));
          }
        };
        const updatePrice = () => {
          const source = html.getElementById(`price-${this.sectionId}`);
          const destination = this.querySelector(
            `#price-${this.dataset.section}`,
          );
          if (!source || !destination) return;
          const klaviyoWidget = destination.querySelector(
            ".klaviyo-star-rating-widget",
          );
          const klaviyoParent = klaviyoWidget?.parentElement;
          if (klaviyoWidget && klaviyoParent) {
            klaviyoParent.removeChild(klaviyoWidget);
          }
          destination.innerHTML = source.innerHTML;
          if (klaviyoWidget) {
            const reviewsContainer = destination.querySelector(
              ".product__price-reviews",
            );
            if (reviewsContainer) {
              const newKlaviyoWidget = reviewsContainer.querySelector(
                ".klaviyo-star-rating-widget",
              );
              if (newKlaviyoWidget) {
                newKlaviyoWidget.remove();
              }
              reviewsContainer.appendChild(klaviyoWidget);
            }
          }
        };
        updatePrice();
        updateSourceFromDestination("Sku", ({ classList }) =>
          classList.contains("hidden"),
        );
        updateSourceFromDestination(
          "Inventory",
          (source) => source.innerText === "",
        );
        updateSourceFromDestination("Volume");
        updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
          classList.contains("hidden"),
        );
        this.updateQuantityRules(this.dataset.section ?? "", html);
        this.querySelector(
          `#Quantity-Rules-${this.dataset.section}`,
        )?.classList.remove("hidden");
        this.querySelector(
          `#Volume-Note-${this.dataset.section}`,
        )?.classList.remove("hidden");
        this.productForm?.toggleSubmitButton(
          html
            .getElementById(`ProductSubmitButton-${this.sectionId}`)
            ?.hasAttribute("disabled") ?? true,
          window.variantStrings.soldOut,
        );
        window.publish(window.PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.sectionId,
            html,
            variant,
          },
        });
      };
    }
    updateVariantInputs(variantId) {
      this.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
      ).forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = variantId ? String(variantId) : "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }
    updateURL(url, variantId) {
      this.querySelector("share-button")?.updateUrl(
        `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`,
      );
      if (this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${url}${variantId ? `?variant=${variantId}` : ""}`,
      );
    }
    setUnavailable() {
      this.productForm?.toggleSubmitButton(
        true,
        window.variantStrings.unavailable,
      );
      const selectors = [
        "price",
        "Inventory",
        "Sku",
        "Price-Per-Item",
        "Volume-Note",
        "Volume",
        "Quantity-Rules",
      ]
        .map((id) => `#${id}-${this.dataset.section}`)
        .join(", ");
      document
        .querySelectorAll(selectors)
        .forEach((element) => element.classList.add("hidden"));
    }
    updateMedia(html, variantFeaturedMediaId) {
      if (!variantFeaturedMediaId) return;
      const mediaGallerySource = this.querySelector("media-gallery ul");
      const mediaGalleryDestination = html.querySelector(`media-gallery ul`);
      const refreshSourceData = () => {
        if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
        const mediaGallerySourceItems = Array.from(
          mediaGallerySource?.querySelectorAll("li[data-media-id]") ?? [],
        );
        const sourceSet = new Set(
          mediaGallerySourceItems.map((item) => item.dataset.mediaId),
        );
        const sourceMap = new Map(
          mediaGallerySourceItems.map((item, index) => [
            item.dataset.mediaId,
            { item, index },
          ]),
        );
        return [mediaGallerySourceItems, sourceSet, sourceMap];
      };
      if (mediaGallerySource && mediaGalleryDestination) {
        let [mediaGallerySourceItems, sourceSet, sourceMap] =
          refreshSourceData();
        const mediaGalleryDestinationItems = Array.from(
          mediaGalleryDestination.querySelectorAll("li[data-media-id]"),
        );
        const destinationSet = new Set(
          mediaGalleryDestinationItems.map((item) => item.dataset.mediaId),
        );
        let shouldRefresh = false;
        for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
          if (
            !sourceSet.has(
              mediaGalleryDestinationItems[i].dataset.mediaId ?? "",
            )
          ) {
            mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
            shouldRefresh = true;
          }
        }
        for (let i = 0; i < mediaGallerySourceItems.length; i++) {
          if (
            !destinationSet.has(
              mediaGallerySourceItems[i].dataset.mediaId ?? "",
            )
          ) {
            mediaGallerySourceItems[i].remove();
            shouldRefresh = true;
          }
        }
        if (shouldRefresh)
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        mediaGalleryDestinationItems.forEach(
          (destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource?.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(
                  `li:nth-of-type(${destinationIndex + 1})`,
                ),
              );
              [mediaGallerySourceItems, sourceSet, sourceMap] =
                refreshSourceData();
            }
          },
        );
      }
      this.querySelector(`media-gallery`)?.setActiveMedia?.(
        `${this.dataset.section}-${variantFeaturedMediaId}`,
        true,
      );
      const modalContent = this.productModal?.querySelector(
        `.product-media-modal__content`,
      );
      const newModalContent = html.querySelector(
        `product-modal .product-media-modal__content`,
      );
      if (modalContent && newModalContent)
        modalContent.innerHTML = newModalContent.innerHTML;
    }
    setQuantityBoundries() {
      if (!this.quantityInput) return;
      const data = {
        cartQuantity: this.quantityInput.dataset.cartQuantity
          ? Number.parseInt(this.quantityInput.dataset.cartQuantity)
          : 0,
        min: this.quantityInput.dataset.min
          ? Number.parseInt(this.quantityInput.dataset.min)
          : 1,
        max: this.quantityInput.dataset.max
          ? Number.parseInt(this.quantityInput.dataset.max)
          : null,
        step: this.quantityInput.step
          ? Number.parseInt(this.quantityInput.step)
          : 1,
      };
      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
      this.quantityInput.min = String(min);
      if (max) {
        this.quantityInput.max = String(max);
      } else {
        this.quantityInput.removeAttribute("max");
      }
      this.quantityInput.value = String(min);
      window.publish(window.PUB_SUB_EVENTS.quantityUpdate, undefined);
    }
    fetchQuantityRules() {
      const currentVariantId = this.productForm?.variantIdInput?.value;
      if (!currentVariantId) return;
      this.querySelector(
        ".quantity__rules-cart .loading__spinner",
      )?.classList.remove("hidden");
      return fetch(
        `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`,
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          this.updateQuantityRules(this.dataset.section ?? "", html);
        })
        .catch((e) => console.error(e))
        .finally(() =>
          this.querySelector(
            ".quantity__rules-cart .loading__spinner",
          )?.classList.add("hidden"),
        );
    }
    updateQuantityRules(sectionId, html) {
      if (!this.quantityInput || !this.quantityForm) return;
      this.setQuantityBoundries();
      const quantityFormUpdated = html.getElementById(
        `Quantity-Form-${sectionId}`,
      );
      if (!quantityFormUpdated) return;
      const selectors = [
        ".quantity__input",
        ".quantity__rules",
        ".quantity__label",
      ];
      for (const selector of selectors) {
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === ".quantity__input") {
          const attributes = [
            "data-cart-quantity",
            "data-min",
            "data-max",
            "step",
          ];
          for (const attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) {
              current.setAttribute(attribute, valueUpdated);
            } else {
              current.removeAttribute(attribute);
            }
          }
        } else {
          current.innerHTML = updated.innerHTML;
          if (selector === ".quantity__label") {
            const updatedAriaLabelledBy =
              updated.getAttribute("aria-labelledby");
            if (updatedAriaLabelledBy) {
              current.setAttribute("aria-labelledby", updatedAriaLabelledBy);
              const labelId = updatedAriaLabelledBy;
              const currentHiddenLabel = document.getElementById(labelId);
              const updatedHiddenLabel = html.getElementById(labelId);
              if (currentHiddenLabel && updatedHiddenLabel) {
                currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
              }
            }
          }
        }
      }
    }
    get productForm() {
      return this.querySelector(`product-form`);
    }
    get productModal() {
      return document.querySelector(`#ProductModal-${this.dataset.section}`);
    }
    get pickupAvailability() {
      return this.querySelector(`pickup-availability`);
    }
    get variantSelectors() {
      return this.querySelector("variant-selects");
    }
    get quickOrderList() {
      const quickOrderListSectionId = SectionId.getIdForSection(
        SectionId.parseId(this.sectionId),
        "quick_order_list",
      );
      return document.querySelector(
        `quick-order-list[data-id^="${quickOrderListSectionId}"]`,
      );
    }
    get sectionId() {
      return this.dataset.originalSection || this.dataset.section || "";
    }
  }
  if (!customElements.get("product-info")) {
    customElements.define("product-info", ProductInfo);
  }
})();
